import React, {Component} from 'react'
import {Accordion, Icon, Grid, Popup} from 'semantic-ui-react'
import {formatDate, sortAndRemoveTaken, sortByExFactory, getRemaining} from './vendor-order-dates'
import {ADD_DAYS_TO_LOADING_DATE} from '../../modules/constants'
import {vpoTicketPopup} from '../vendor-orders/vpo-ticket-popup'

const labelStyle = {
  position: 'absolute',
  bottom: '16px',
  fontSize: '9px',
  height: '17px',
  opacity: 0.3
}

const colStyle = {textOverflow: 'ellipsis', overflow: 'hidden'}

class VendorOrderAccordion extends Component {
  constructor(props) {
    super(props)
    this.state = {active: false}
  }

  toggleAccordion = () => this.setState({active: !this.state.active})

  render() {
    let {orders, cad, orderType, expandAll, isQbApiOrg} = this.props
    let {active} = this.state

    if (isQbApiOrg) {
      orders = getRemaining(orders)
    }

    if (orderType == 'Future ATS') {
      orders = sortAndRemoveTaken(orders, cad)
    } else {
      orders = sortByExFactory(orders)
    }

    if (expandAll) {
      active = true
    }

    const total = orders.reduce((accumulator, currentValue) => {
      return accumulator + Number(currentValue.qty)
    }, 0)

    return (
      <React.Fragment>
        <Accordion>
          <Accordion.Title onClick={expandAll ? () => {} : this.toggleAccordion} >
            {orderType == "Future ATS" ? <Icon name="clock"/> : <Icon name="factory"/>}

            {orderType}

            {
              total > 0
              ?
              <Icon name='dropdown' style={active ? {rotate: '90deg'} : {rotate: '180deg'}}/>
              :
              null
            }
          </Accordion.Title>
          <div><span style={{fontSize: '20px', color: total > 0 ? 'rgb(82,174,100)' : 'gray', marginLeft: '21px'}}>{total}</span></div>
          <Accordion.Content active={active && total > 0}>
            <Grid stackable columns={4}>
              {orders.map((x, index) => {
                const isLoading = x.loading_date != null

                return (
                  <React.Fragment>
                    <Grid.Row>
                      <Grid.Column>{x.qty}</Grid.Column>
                      <Grid.Column style={colStyle}>{x.factory_id}</Grid.Column>
                      <Grid.Column><div style={labelStyle}>Ex-Factory</div>{x.ex_factory}</Grid.Column>
                      <Grid.Column>{formatDate(x.ex_factory, false)}</Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={4} style={isLoading ? {marginTop: '-15px'} : {marginTop: '-15px', borderBottom: '1px solid rgb(212,212,212)'}}>
                      <Grid.Column style={{whiteSpace: 'nowrap'}}>{x.vponumber}{vpoTicketPopup(x.ticketed)}</Grid.Column>
                      <Grid.Column>{x.container_number}</Grid.Column>
                      {isLoading ?
                        <Grid.Column><div style={labelStyle}>Loading Date</div>{x.loading_date}</Grid.Column>
                      : null}
                      {
                        isQbApiOrg && Number(x.received) > 0 && orderType == "Future Stock" && 
                        <Grid.Column>
                          received: {x.received}
                        </Grid.Column>
                      }
                    </Grid.Row>
                    {
                      isLoading ?
                      <Grid.Row columns={3} style={{marginTop: '-15px', borderBottom: '1px solid rgb(212,212,212)'}}>
                        <Grid.Column>{formatDate(x.loading_date, true)}</Grid.Column>
                      </Grid.Row>
                      :
                      null
                    }


                  </React.Fragment>
                )
              })}
            </Grid>
          </Accordion.Content>
        </Accordion>
      </React.Fragment>
    )
  }
}

export default VendorOrderAccordion
